import axios, { Method } from 'axios';
import { Toast } from 'antd-mobile'
import Cookies from 'js-cookie';
import { setupAxiosInterceptor } from '@eworld/uc-auth/packages/react'
import packageJson from '../../package.json'
import { getUcCode } from '@/utils';

declare module 'axios' {
  interface AxiosInstance {
    (config: AxiosRequestConfig): Promise<any>;
  }
  interface AxiosRequestConfig {
    silent?: boolean; // 静默模式，不显示错误提示
    skipAuthLogin?: boolean; // 跳过登录重定向
    skipToken?: boolean; // 跳过 token 注入
  }
}

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  timeout: 60000, // request timeout
})

// 请求拦截器：添加 token
instance.interceptors.request.use((request) => {

  

  request.headers['X-App-Version'] = packageJson.version;
  const platformCs = Cookies.get('platform_cs');
  if (platformCs) {
    request.headers['x-platform-cs'] = platformCs;
  }

  if (!request.skipToken) {
    const token = localStorage.getItem('token');
    if (token) {
      request.headers['token'] = token;
    }
  }
  return request;
});

// 非海外环境：设置 UC Auth 拦截器（自动处理 12016 和 12018 错误码）
if (process.env.REACT_APP_IDN_ENV !== 'hw') {
  setupAxiosInterceptor(instance as any, {
    ucCode: getUcCode(),
    environment: process.env.REACT_APP_REAL_ENV as 'development' | 'test' | 'production',
    getAccessToken: () => localStorage.getItem('token'),
    onRefreshSuccess: (newToken) => {
      localStorage.setItem('token', newToken);
    },
  });
}

// 添加响应拦截器
instance.interceptors.response.use(response => {
  const res = response.data;
  const silent = response.config?.silent; // 获取静默参数
  // 处理海外：token 失效，清除登录信息并跳转到首页，触发登录弹框
  if (process.env.REACT_APP_IDN_ENV === 'hw' && (res?.code === 10101 || res?.code === 10110)) {
    // window.location.href = '/show-status'
    localStorage.removeItem('token');
    localStorage.removeItem('role');  // 清除角色信息
    // 跳转到首页，Layout 会检测到无 token 并自动显示登录弹框
    window.location.href = '/'
    return;
  }
  if (res?.code === 0) {
    return res;
  } else if (res?.code !== 12016 && res?.code !== 12018) {
    // 静默模式下不显示错误提示
    if (!silent && res.msg) {
      Toast.show({ icon: 'fail', content: res.msg });
    }
  }
  return response;

}, error => {
  const message = error?.response ? error.response.status : error.message;
  const silent = error?.config?.silent; // 获取静默参数
  // 静默模式下不显示错误提示
  if (!silent && message) {
    Toast.show({ icon: 'fail', content: message });
  }
  return Promise.reject(error);
});




// 底层请求方法
function baseRequest(method: Method, url: string, opts) {
  const config = { method, url, headers: {}, ...opts };
  // const token = localStorage.getItem('token');
  // token && (config.headers.token = token);
  return instance(config);
}


export function baseGet(url: string, params?: any, options?: { silent?: boolean }) {
  return baseRequest('GET', url, { params, ...options });
}

export function basePost(url: string, data?: any, options?: { silent?: boolean, skipAuthLogin?: boolean }) {
  return baseRequest('POST', url, { data, ...options });
}

export function noTokenGet(url: string, params?: any, headers: any = {}) {
  return instance({
    method: 'GET',
    url: url,
    params,
    headers,
    skipToken: true,
  })
}

export function noTokenPost(url: string, data?: any, headers: any = {}) {
  return instance({
    method: 'POST',
    url: url,
    data,
    headers,
    skipToken: true,
  })
}

// 导入
export function baseImport(url: string, data?: Record<string, any>) {
  return baseRequest('POST', url, { data, headers: { 'Content-Type': 'multipart/form-data' } });
}
